import script from "./TaskInlineMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskInlineMobile.vue?vue&type=script&setup=true&lang=ts"

import "./TaskInlineMobile.vue?vue&type=style&index=0&id=b6d06b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6d06b72"]])

export default __exports__